var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDeleteDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01 Icons/01 Small/ic-delete") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01-Icons/01-Small/ic-delete",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uF1F8",
    transform: "translate(4.000000, 3.250000)",
    fill: "#373A37",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.74609375,0.6328125 L4.5,1.125 L1.125,1.125 C0.796875,1.125 0.52734375,1.23046875 0.31640625,1.44140625 C0.10546875,1.65234375 0,1.921875 0,2.25 C0,2.578125 0.10546875,2.84765625 0.31640625,3.05859375 C0.52734375,3.26953125 0.796875,3.375 1.125,3.375 L14.625,3.375 C14.953125,3.375 15.2226562,3.26953125 15.4335938,3.05859375 C15.6445312,2.84765625 15.75,2.578125 15.75,2.25 C15.75,1.921875 15.6445312,1.65234375 15.4335938,1.44140625 C15.2226562,1.23046875 14.953125,1.125 14.625,1.125 L11.25,1.125 L11.0039062,0.6328125 C10.7929688,0.234375 10.453125,0.0234375 9.984375,0 L5.765625,0 C5.296875,0.0234375 4.95703125,0.234375 4.74609375,0.6328125 Z M14.625,4.5 L1.125,4.5 L1.86328125,16.4179688 C1.91015625,16.8632812 2.0859375,17.2382812 2.390625,17.5429688 C2.71875,17.8476562 3.10546875,18 3.55078125,18 L12.1992188,18 C12.6445312,18 13.03125,17.8476562 13.359375,17.5429688 C13.6640625,17.2382812 13.8398438,16.8632812 13.8867188,16.4179688 L14.625,4.5 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeleteDark);
export default __webpack_public_path__ + "static/media/ic-delete-dark.c391773d558f2f61794b82b70541d253.svg";
export { ForwardRef as ReactComponent };